import { useCallback, useEffect, useState } from "react";
import { CalendlyExpert } from "../../../utils/api-objects/CalendlyExpert";
import { getMedicaluserByRole } from "../../../utils/apis/medical-user-service";
import { useAuth } from "../../../utils/context/AuthContext";
import { ExpertRole } from "../../../utils/Enums";

export const useGetAdmins = () => {
    const { auth } = useAuth();
    const idToken = auth.idToken;

    const [admins, setAdmins] = useState<CalendlyExpert[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    const fetchAdmins = useCallback(async () => {
        if (!idToken) return;
        setIsLoading(true);
        setError(null);

        try {
            const result: CalendlyExpert[] | null = await getMedicaluserByRole(idToken, ExpertRole.Admin);
            if (result !== null) {
                setAdmins(result);
            }
        } catch (err: any) {
            console.error("Failed to fetch admins:", err);
            setError(err);
        } finally {
            setIsLoading(false);
        }
    }, [idToken]);

    useEffect(() => {
        fetchAdmins();
    }, [fetchAdmins]);

    return { admins, isLoading, error, refetch: fetchAdmins };
}